{
  "Afghanistan": [33.93, 67.71],
  "Albania": [41.15, 20.17],
  "Algeria": [28.03, 1.66],
  "Andorra": [42.55, 1.6],
  "Angola": [-11.2, 17.87],
  "Antigua and Barbuda": [17.06, -61.8],
  "Argentina": [-38.42, -63.62],
  "Armenia": [40.07, 44.95],
  "Australia": [-25.27, 133.78],
  "Austria": [47.52, 14.55],
  "Azerbaijan": [40.14, 47.58],
  "Bahamas": [25.03, -77.4],
  "Bahrain": [26.07, 50.56],
  "Bangladesh": [23.68, 90.36],
  "Barbados": [13.19, -59.54],
  "Belarus": [53.71, 27.95],
  "Belgium": [50.5, 4.47],
  "Belize": [17.19, -88.5],
  "Benin": [9.31, 2.32],
  "Bhutan": [27.51, 90.43],
  "Bolivia": [-16.29, -63.59],
  "Bosnia and Herzegovina": [43.92, 17.68],
  "Botswana": [-22.33, 24.68],
  "Brazil": [-14.24, -51.93],
  "Brunei": [4.54, 114.73],
  "Bulgaria": [42.73, 25.49],
  "Burkina Faso": [12.24, -1.56],
  "Burundi": [-3.37, 29.92],
  "Cabo Verde": [16, -24.01],
  "Cape Verde": [16, -24.01],
  "Cambodia": [12.57, 104.99],
  "Cameroon": [7.37, 12.35],
  "Canada": [56.13, -106.35],
  "Central African Republic": [6.61, 20.94],
  "CAR": [6.61, 20.94],
  "Chad": [15.45, 18.73],
  "Chile": [-35.68, -71.54],
  "China": [35.86, 104.2],
  "Colombia": [4.57, -74.3],
  "Comoros": [-11.88, 43.33],
  "Congo": [-1.44, 15.56],
  "Congo (Democratic Republic)": [0.04, 21.76],
  "Costa Rica": [9.75, -83.75],
  "C\u00f4te d'Ivoire": [7.54, -5.55],
  "Croatia": [45.1, 15.2],
  "Cuba": [21.52, -77.78],
  "Cyprus": [35.13, 33.43],
  "Czech Republic": [49.82, 15.47],
  "Czechia": [49.82, 15.47],
  "Denmark": [56.26, 9.5],
  "Djibouti": [11.83, 42.59],
  "Dominica": [15.41, -61.37],
  "Dominican Republic": [18.74, -70.16],
  "Ecuador": [-1.83, -78.18],
  "Egypt": [26.82, 30.8],
  "El Salvador": [13.79, -88.9],
  "Equatorial Guinea": [1.65, 10.27],
  "Eritrea": [15.18, 39.78],
  "Estonia": [58.6, 25.01],
  "Eswatini": [-26.52, 31.47],
  "Swaziland": [-26.52, 31.47],
  "Ethiopia": [9.03, 38.75],
  "Fiji": [-17.71, 178.07],
  "Finland": [61.92, 25.75],
  "France": [46.6, 2.35],
  "Gabon": [-0.8, 11.61],
  "Gambia": [13.44, -15.31],
  "Georgia": [42.32, 43.36],
  "Germany": [51.17, 10.45],
  "Ghana": [7.95, -1.02],
  "Greece": [39.07, 21.82],
  "Grenada": [12.26, -61.6],
  "Guatemala": [15.78, -90.23],
  "Guinea": [9.95, -9.7],
  "Guinea-Bissau": [11.8, -15.18],
  "Guyana": [4.86, -58.93],
  "Haiti": [18.97, -72.29],
  "Honduras": [15.2, -86.24],
  "Hungary": [47.16, 19.5],
  "Iceland": [64.96, -19.02],
  "India": [20.59, 78.96],
  "Indonesia": [-2.55, 118.02],
  "Iran": [32.43, 53.69],
  "Iraq": [33.22, 43.68],
  "Ireland": [53.14, -8.24],
  "Israel": [31.05, 34.85],
  "Italy": [41.87, 12.57],
  "Jamaica": [18.11, -77.3],
  "Japan": [36.2, 138.25],
  "Jordan": [30.59, 36.24],
  "Kazakhstan": [48.02, 66.92],
  "Kenya": [-1.29, 36.82],
  "Kiribati": [1.35, 172.98],
  "Korea, North": [40.34, 127.51],
  "Korea, South": [35.91, 127.77],
  "North Korea": [40.34, 127.51],
  "South Korea": [35.91, 127.77],
  "Kuwait": [29.31, 47.48],
  "Kyrgyzstan": [41.2, 74.77],
  "Laos": [19.86, 102.5],
  "Latvia": [56.88, 24.6],
  "Lebanon": [33.85, 35.86],
  "Lesotho": [-29.61, 28.23],
  "Liberia": [6.43, -9.43],
  "Libya": [26.34, 17.23],
  "Liechtenstein": [47.17, 9.56],
  "Lithuania": [55.17, 23.88],
  "Luxembourg": [49.82, 6.13],
  "Madagascar": [-18.77, 46.87],
  "Malawi": [-13.25, 34.3],
  "Malaysia": [4.21, 101.98],
  "Maldives": [3.2, 73.22],
  "Mali": [17.57, -4],
  "Malta": [35.94, 14.38],
  "Marshall Islands": [7.13, 171.18],
  "Mauritania": [21.01, -10.94],
  "Mauritius": [-20.35, 57.55],
  "Mexico": [23.63, -102.55],
  "Micronesia": [7.43, 150.55],
  "Moldova": [47.41, 28.37],
  "Monaco": [43.73, 7.42],
  "Mongolia": [46.86, 103.85],
  "Montenegro": [42.71, 19.37],
  "Morocco": [31.79, -7.09],
  "Mozambique": [-18.67, 35.53],
  "Myanmar": [21.91, 95.96],
  "Burma": [21.91, 95.96],
  "Namibia": [-22.96, 18.49],
  "Nauru": [-0.52, 166.93],
  "Nepal": [28.39, 84.12],
  "Netherlands": [52.13, 5.29],
  "New Zealand": [-40.9, 174.89],
  "Nicaragua": [12.87, -85.21],
  "Niger": [17.61, 8.08],
  "Nigeria": [9.08, 8.68],
  "North Macedonia": [41.5, 21.75],
  "Norway": [65.47, 13.18],
  "Oman": [21.47, 55.98],
  "Pakistan": [30.38, 69.35],
  "Palestine": [31.95, 35.23],
  "Panama": [9.1, -79.4],
  "Papua New Guinea": [-6.31, 143.96],
  "Paraguay": [-23.44, -58.44],
  "Peru": [-9.19, -75.02],
  "Philippines": [12.88, 121.77],
  "Poland": [51.92, 19.15],
  "Portugal": [39.4, -8.22],
  "Qatar": [25.35, 51.18],
  "Romania": [45.94, 24.97],
  "Russia": [61.52, 105.32],
  "Russian Federation": [61.52, 105.32],
  "Rwanda": [-1.94, 29.87],
  "Saint Kitts and Nevis": [17.36, -62.78],
  "Saint Lucia": [13.91, -60.98],
  "Saint Vincent and the Grenadines": [12.98, -61.29],
  "Samoa": [-13.76, -172.1],
  "San Marino": [43.94, 12.46],
  "S\u00e3o Tom\u00e9 and Pr\u00edncipe": [0.19, 6.61],
  "Saudi Arabia": [23.89, 45.08],
  "Senegal": [14.5, -14.45],
  "Serbia": [44.02, 21.01],
  "Seychelles": [-4.68, 55.49],
  "Sierra Leone": [8.46, -11.78],
  "Singapore": [1.35, 103.82],
  "Slovakia": [48.67, 19.7],
  "Slovenia": [46.15, 14.99],
  "Solomon Islands": [-9.65, 160.16],
  "Somalia": [5.15, 46.2],
  "South Africa": [-30.56, 22.94],
  "South Sudan": [6.88, 31.31],
  "Spain": [40.46, -3.75],
  "Sri Lanka": [7.87, 80.77],
  "Sudan": [15.5, 32.56],
  "Suriname": [3.92, -56.03],
  "Sweden": [60.13, 18.64],
  "Switzerland": [46.82, 8.23],
  "Syria": [34.8, 38.99],
  "Tajikistan": [38.86, 71.28],
  "Tanzania": [-6.37, 34.89],
  "Thailand": [15.87, 100.99],
  "Timor-Leste": [-8.87, 125.73],
  "East Timor": [-8.87, 125.73],
  "Togo": [8.62, 1.21],
  "Tonga": [-21.18, -175.2],
  "Trinidad and Tobago": [11.29, -61.24],
  "Tunisia": [33.89, 9.54],
  "Turkey": [38.96, 35.24],
  "Turkmenistan": [38.97, 59.56],
  "Tuvalu": [-8.52, 179.2],
  "Uganda": [1.37, 32.29],
  "Ukraine": [48.38, 31.17],
  "United Arab Emirates": [23.42, 53.85],
  "United Kingdom": [55.38, -3.44],
  "UK": [55.38, -3.44],
  "United States": [39.83, -98.58],
  "USA": [39.83, -98.58],
  "US": [39.83, -98.58],
  "Uruguay": [-32.52, -55.77],
  "Uzbekistan": [41.38, 64.59],
  "Vanuatu": [-15.38, 166.96],
  "Vatican City": [41.9, 12.45],
  "Venezuela": [6.42, -66.59],
  "Vietnam": [14.06, 108.28],
  "Yemen": [15.55, 48.52],
  "Zambia": [-13.13, 28.64],
  "Zimbabwe": [-19.02, 29.15],
  "Taiwan": [23.7, 120.96],
  "Hong Kong": [22.4, 114.11],
  "Macau": [22.2, 113.54],
  "Puerto Rico": [18.22, -66.59],
  "Greenland": [71.71, -42.6],
  "Guam": [13.44, 144.79],
  "Bermuda": [32.32, -64.76],
  "Cayman Islands": [19.51, -80.57],
  "Gibraltar": [36.14, -5.35],
  "Faroe Islands": [61.89, -6.91],
  "French Guiana": [3.93, -53.13],
  "R\u00e9union": [-21.12, 55.54],
  "New Caledonia": [-20.9, 165.62],
  "French Polynesia": [-17.68, -149.41],
  "Martinique": [14.64, -61.02],
  "Guadeloupe": [16.27, -61.55],
  "Cura\u00e7ao": [12.17, -68.98],
  "Aruba": [12.51, -69.97],
  "Kosovo": [42.6, 20.9],
  "Western Sahara": [24.22, -12.89],
  "Somaliland": [9.56, 44.06],
  "Crimea": [44.95, 34.1],
  "US Virgin Islands": [18.34, -64.9],
  "Algiers": [28.03, 1.66],
  "Luanda": [-11.2, 17.87],
  "Buenos Aires": [-38.42, -63.62],
  "Yerevan": [40.07, 44.95],
  "Canberra": [-25.27, 133.78],
  "Sydney": [-25.27, 133.78],
  "Melbourne": [-25.27, 133.78],
  "Vienna": [47.52, 14.55],
  "Baku": [40.14, 47.58],
  "Manama": [26.07, 50.56],
  "Dhaka": [23.68, 90.36],
  "Minsk": [53.71, 27.95],
  "Brussels": [50.5, 4.47],
  "Thimphu": [27.51, 90.43],
  "La Paz": [-16.29, -63.59],
  "Sarajevo": [43.92, 17.68],
  "Gaborone": [-22.33, 24.68],
  "Bras\u00edlia": [-14.24, -51.93],
  "Sofia": [42.73, 25.49],
  "Ouagadougou": [12.24, -1.56],
  "Phnom Penh": [12.57, 104.99],
  "Yaound\u00e9": [7.37, 12.35],
  "Ottawa": [56.13, -106.35],
  "Toronto": [56.13, -106.35],
  "N'Djamena": [15.45, 18.73],
  "Santiago": [-35.68, -71.54],
  "Beijing": [35.86, 104.2],
  "Shanghai": [35.86, 104.2],
  "Guangzhou": [35.86, 104.2],
  "Shenzhen": [35.86, 104.2],
  "Chengdu": [35.86, 104.2],
  "Bogot\u00e1": [4.57, -74.3],
  "San Jos\u00e9": [9.75, -83.75],
  "Abidjan": [7.54, -5.55],
  "Zagreb": [45.1, 15.2],
  "Havana": [21.52, -77.78],
  "Nicosia": [35.13, 33.43],
  "Prague": [49.82, 15.47],
  "Copenhagen": [56.26, 9.5],
  "Quito": [-1.83, -78.18],
  "Cairo": [26.82, 30.8],
  "San Salvador": [13.79, -88.9],
  "Malabo": [1.65, 10.27],
  "Asmara": [15.18, 39.78],
  "Tallinn": [58.6, 25.01],
  "Mbabane": [-26.52, 31.47],
  "Addis Ababa": [9.03, 38.75],
  "Suva": [-17.71, 178.07],
  "Helsinki": [61.92, 25.75],
  "Paris": [46.6, 2.35],
  "Libreville": [-0.8, 11.61],
  "Banjul": [13.44, -15.31],
  "Tbilisi": [42.32, 43.36],
  "Munich": [51.17, 10.45],
  "Frankfurt": [51.17, 10.45],
  "Hamburg": [51.17, 10.45],
  "Accra": [7.95, -1.02],
  "Athens": [39.07, 21.82],
  "Guatemala City": [15.78, -90.23],
  "Conakry": [9.95, -9.7],
  "Georgetown": [4.86, -58.93],
  "Port-au-Prince": [18.97, -72.29],
  "Tegucigalpa": [15.2, -86.24],
  "Budapest": [47.16, 19.5],
  "Reykjavik": [64.96, -19.02],
  "New Delhi": [20.59, 78.96],
  "Delhi": [20.59, 78.96],
  "Mumbai": [20.59, 78.96],
  "Bangalore": [20.59, 78.96],
  "Chennai": [20.59, 78.96],
  "Kolkata": [20.59, 78.96],
  "Jakarta": [-2.55, 118.02],
  "Tehran": [32.43, 53.69],
  "Isfahan": [32.43, 53.69],
  "Baghdad": [33.22, 43.68],
  "Basra": [33.22, 43.68],
  "Erbil": [33.22, 43.68],
  "Dublin": [53.14, -8.24],
  "Jerusalem": [31.05, 34.85],
  "Tel Aviv": [31.05, 34.85],
  "Rome": [41.87, 12.57],
  "Milan": [41.87, 12.57],
  "Kingston": [18.11, -77.3],
  "Tokyo": [36.2, 138.25],
  "Osaka": [36.2, 138.25],
  "Amman": [30.59, 36.24],
  "Astana": [48.02, 66.92],
  "Nur-Sultan": [48.02, 66.92],
  "Nairobi": [-1.29, 36.82],
  "Pyongyang": [40.34, 127.51],
  "Seoul": [35.91, 127.77],
  "Kuwait City": [29.31, 47.48],
  "Bishkek": [41.2, 74.77],
  "Vientiane": [19.86, 102.5],
  "Riga": [56.88, 24.6],
  "Beirut": [33.85, 35.86],
  "Maseru": [-29.61, 28.23],
  "Monrovia": [6.43, -9.43],
  "Tripoli": [26.34, 17.23],
  "Vaduz": [47.17, 9.56],
  "Vilnius": [55.17, 23.88],
  "Luxemborg": [49.82, 6.13],
  "Antananarivo": [-18.77, 46.87],
  "Lilongwe": [-13.25, 34.3],
  "Kuala Lumpur": [4.21, 101.98],
  "Mal\u00e9": [3.2, 73.22],
  "Bamako": [17.57, -4],
  "Valletta": [35.94, 14.38],
  "Majuro": [7.13, 171.18],
  "Nouakchott": [21.01, -10.94],
  "Mexico City": [23.63, -102.55],
  "Chisinau": [47.41, 28.37],
  "Ulaanbaatar": [46.86, 103.85],
  "Rabat": [31.79, -7.09],
  "Casablanca": [31.79, -7.09],
  "Maputo": [-18.67, 35.53],
  "Naypyidaw": [21.91, 95.96],
  "Yangon": [21.91, 95.96],
  "Windhoek": [-22.96, 18.49],
  "Kathmandu": [28.39, 84.12],
  "Amsterdam": [52.13, 5.29],
  "The Hague": [52.13, 5.29],
  "Wellington": [-40.9, 174.89],
  "Auckland": [-40.9, 174.89],
  "Managua": [12.87, -85.21],
  "Niamey": [17.61, 8.08],
  "Abuja": [9.08, 8.68],
  "Lagos": [9.08, 8.68],
  "Oslo": [65.47, 13.18],
  "Muscat": [21.47, 55.98],
  "Islamabad": [30.38, 69.35],
  "Karachi": [30.38, 69.35],
  "Lahore": [30.38, 69.35],
  "Ramallah": [31.95, 35.23],
  "Panama City": [9.1, -79.4],
  "Port Moresby": [-6.31, 143.96],
  "Asunci\u00f3n": [-23.44, -58.44],
  "Lima": [-9.19, -75.02],
  "Manila": [12.88, 121.77],
  "Warsaw": [51.92, 19.15],
  "Lisbon": [39.4, -8.22],
  "Doha": [25.35, 51.18],
  "Bucharest": [45.94, 24.97],
  "Moscow": [61.52, 105.32],
  "Saint Petersburg": [61.52, 105.32],
  "Kigali": [-1.94, 29.87],
  "Riyadh": [23.89, 45.08],
  "Jeddah": [23.89, 45.08],
  "Dakar": [14.5, -14.45],
  "Belgrade": [44.02, 21.01],
  "Victoria": [22.4, 114.11],
  "Freetown": [8.46, -11.78],
  "Bratislava": [48.67, 19.7],
  "Ljubljana": [46.15, 14.99],
  "Honiara": [-9.65, 160.16],
  "Mogadishu": [5.15, 46.2],
  "Pretoria": [-30.56, 22.94],
  "Juba": [6.88, 31.31],
  "Madrid": [40.46, -3.75],
  "Barcelona": [40.46, -3.75],
  "Colombo": [7.87, 80.77],
  "Khartoum": [15.5, 32.56],
  "Stockholm": [60.13, 18.64],
  "Bern": [46.82, 8.23],
  "Zurich": [46.82, 8.23],
  "Geneva": [46.82, 8.23],
  "Damascus": [34.8, 38.99],
  "Aleppo": [34.8, 38.99],
  "Dushanbe": [38.86, 71.28],
  "Dar es Salaam": [-6.37, 34.89],
  "Dodoma": [-6.37, 34.89],
  "Bangkok": [15.87, 100.99],
  "Lom\u00e9": [8.62, 1.21],
  "Tunis": [33.89, 9.54],
  "Ankara": [38.96, 35.24],
  "Istanbul": [38.96, 35.24],
  "Ashgabat": [38.97, 59.56],
  "Kampala": [1.37, 32.29],
  "Kyiv": [48.38, 31.17],
  "Kiev": [48.38, 31.17],
  "Abu Dhabi": [24.47, 54.37],
  "Dubai": [24.47, 54.37],
  "London": [55.38, -3.44],
  "Edinburgh": [55.38, -3.44],
  "Manchester": [55.38, -3.44],
  "Washington, D.C.": [39.83, -98.58],
  "Washington": [39.83, -98.58],
  "New York": [39.83, -98.58],
  "Los Angeles": [39.83, -98.58],
  "Chicago": [39.83, -98.58],
  "San Francisco": [39.83, -98.58],
  "Houston": [39.83, -98.58],
  "Montevideo": [-32.52, -55.77],
  "Tashkent": [41.38, 64.59],
  "Caracas": [6.42, -66.59],
  "Hanoi": [14.06, 108.28],
  "Ho Chi Minh City": [14.06, 108.28],
  "Sanaa": [15.55, 48.52],
  "Lusaka": [-13.13, 28.64],
  "Harare": [-19.02, 29.15],
  "Taipei": [23.7, 120.96],
  "San Juan": [18.22, -66.59],
  "Nuuk": [71.71, -42.6],
  "Hagatna": [13.44, 144.79],
  "Hamilton": [32.32, -64.76],
  "George Town": [19.51, -80.57],
  "Northeast Asia": [45, 120],
  "Southeast Asia": [2.5, 112],
  "South Asia": [20.59, 78.96],
  "Central Asia": [43, 68],
  "Africa": [-8.78, 22],
  "Sub-Saharan Africa": [-8.78, 22],
  "North Africa": [28, 10],
  "West Africa": [10, -3],
  "East Africa": [-1, 37],
  "Southern Africa": [-25, 26],
  "Horn of Africa": [8, 43],
  "Sahel": [15, 3],
  "Europe": [54.53, 15.26],
  "Eastern Europe": [50, 30],
  "Western Europe": [48, 5],
  "Northern Europe": [60, 15],
  "Southern Europe": [40, 15],
  "Balkans": [43, 20],
  "Baltic States": [57, 24],
  "Scandinavia": [62, 15],
  "Latin America": [-15, -60],
  "Central America": [14, -87],
  "Caribbean": [18, -72],
  "South America": [-15, -60],
  "North America": [45, -100],
  "Oceania": [-22, 155],
  "Pacific Islands": [-5, 165],
  "Persian Gulf": [27, 51],
  "Gulf States": [25, 50],
  "Levant": [33.5, 36.5],
  "Maghreb": [32, 3],
  "MENA": [28, 35],
  "Indo-Pacific": [5, 110],
  "Arctic": [75, 0],
  "Antarctic": [-80, 0],
  "Caucasus": [42, 44.5],
  "Black Sea": [43.5, 34],
  "Caspian": [41.5, 51],
  "ASEAN": [5, 110],
  "GCC": [24, 48],
  "EU": [50, 10],
  "NATO": [50, 10],
  "G7": [48, 10],
  "BRICS": [20, 60],
  "Middle East": [29, 42],
  "UAE": [23.42, 53.85],
  "Strait of Hormuz": [26.57, 56.25],
  "Asia-Pacific": [10, 120],
  "Global South": [-5, 25],
  "Global": [20, 0],
  "Suez Canal": [30.46, 32.34]
}
